import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CustomerSupportAside from './CustomerSupportAside';

function DeveloperChecklist() {

    const [selectedSchoolId, setSelectedSchoolId] = useState("");
    const [schoolDetails, setSchoolDetails] = useState([]);
    const [checklistData, setChecklistData] = useState([]);
    const [loading, setLoading] = useState(false);

    // Fetch schools
    useEffect(() => {
        setLoading(true);

        axios
            .get("https://cleezoclass.com:8443/api/schools")
            .then((response) => {
                setSchoolDetails(response.data);
            })
            .catch((error) => {
                console.error("School Fetch Error:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    // Fetch checklist when school selected
    useEffect(() => {

        if (!selectedSchoolId) {
            setChecklistData([]);
            return;
        }

        axios
            .get(`https://cleezoclass.com:8443/api/checklist/${selectedSchoolId}`)
            .then((response) => {
                setChecklistData(response.data || []);
            })
            .catch((error) => {
                console.error("Checklist Fetch Error:", error);
                setChecklistData([]);
            });

    }, [selectedSchoolId]);

    return (
        <div className="mainBlock">

            <h2>Developer Checklist</h2>

            <CustomerSupportAside />

            <div className="cust-spt-conatiner cust-checklist">

                <h1>Checklist View</h1>

                <label>Select School :</label>

                <select
                    className="cust-spt-checklist-select"
                    value={selectedSchoolId}
                    onChange={(e) => setSelectedSchoolId(e.target.value)}
                >
                    <option value="">Select School</option>

                    {schoolDetails.map((school) => (
                        <option
                            key={school.id}
                            value={school.id}
                        >
                            {school.institute_name}
                        </option>
                    ))}
                </select>

                {loading && <p>Loading Schools...</p>}

                {!selectedSchoolId && (
                    <p>Please select a school.</p>
                )}

                {selectedSchoolId && (
                    <div className="cust-spt-checklist">

                        <h2>Saved Checklist</h2>

                        {checklistData.length === 0 ? (
                            <p>No checklist found.</p>
                        ) : (
                            <div className="checklist-container">

                                {checklistData.map((item) => (
                                    <div
                                        key={item.id}
                                        className="checklist-card"
                                    >
                                        <label className="checklist-item">

                                            <input
                                                type="checkbox"
                                                checked={item.isChecked}
                                                disabled
                                            />

                                            <span>
                                                {item.text}
                                            </span>

                                        </label>
                                    </div>
                                ))}

                            </div>
                        )}

                    </div>
                )}

            </div>

        </div>
    );
}

export default DeveloperChecklist;